import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { timeFormatter } from "../../components/DtFormatter";
import Header from "../../components/Header";
import axios from "axios";
import { FindInPage, Add } from "@material-ui/icons";
import Cookies from "universal-cookie";
import AddSchema from "./AddSchema";
import DeleteSchema from "./DeleteSchema";
const cookies = new Cookies();

const access = ["No Access", "View Only", "Add", "Add / Edit", "Full Access"];

export default function BasicSchema(props) {
  const permissions = cookies.get("permissions")['config'];
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [filteredData, setFilteredData] = useState([]);
  const [companyDD, setCompanyDD] = useState([]);
  const [fileLoaded, setFileLoaded] = useState(false);
  const [search, setSearch] = useState(
    props.location.search
      ? decodeURI(props.location.search.split("=").pop())
      : ""
  );

  useEffect(() => {
    const fetchData = async () => {
      let apiLink = "api/basic_schema";
      const res = await axios.get(apiLink);
      setData(res.data);
      const filterer = searcher(res.data, search);
      setFilteredData(filterer);
    };

    const fetchCompanyDD = async () => {
      let apiLink = "api/company";
      const res = await axios.get(apiLink);
      setCompanyDD(res.data);
    };

    if (!fileLoaded) {
      fetchData();
      fetchCompanyDD();
      setFileLoaded(true);
    }
  });

  const handleAddCallback = (editData) => {
    if (editData) {
      setFileLoaded(false);
    }
  };

  const pages = [];
  for (let i = 1; i <= Math.ceil(filteredData.length / recordsPerPage); i++) {
    pages.push(i);
  }

  const handleRecordPerPage = (e) => {
    console.log(e.target.value);
    setRecordsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const handleSearch = (e) => {
    const filterer = searcher(data, e.target.value);
    setFilteredData(filterer);
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  const searcher = (data, searchString) => {
    const searchedData = data.filter(function (data) {
      for (var key in data) {
        if (
          !(
            data["code"].toLowerCase().includes(searchString.toLowerCase()) ||
            data["description"].toLowerCase().includes(searchString.toLowerCase())
          )
        ) {
          return false;
        }
        return true;
      }
    });

    return searchedData;
  };

  const startIndex = currentPage * recordsPerPage - recordsPerPage;
  const endIndex = startIndex + recordsPerPage;
  const currentData = filteredData.slice(startIndex, endIndex);

  return (
    <div className="hk-wrapper hk-vertical-nav">
      <div class="pg-hk-wrapper">
        <Header />
        <div className="mt-20 hk-pg-wrapper">
          {permissions > 0 ? (
            <div className="container-fluid">
              <div className="row mb-10">
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <h3>Basic Pay Schemas</h3>
                </div>

                <div className="col-lg-6 col-md-6 col-sm-12">
                  {permissions > 1 ? (
                    <AddSchema
                      companyDD={companyDD}
                      parentCallback={handleAddCallback}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="table-wrap">
                      <div className="row mb-10">
                        <div className="col-md-6">
                          <label>
                            <select
                              className="custom-select custom-select-sm form-control form-control-sm"
                              onChange={handleRecordPerPage}
                            >
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                            </select>
                          </label>{" "}
                          items
                        </div>
                        <div className="col-md-6">
                          <input
                            type="search"
                            className="form-control form-control-sm col-md-6 col-sm-6 float-right"
                            placeholder="Search"
                            defaultValue={
                              props.location.search
                                ? decodeURI(
                                    props.location.search.split("=").pop()
                                  )
                                : ""
                            }
                            onChange={handleSearch}
                          />
                        </div>
                      </div>
                      <div className="table-responsive mb-10">
                        <table className="table table-sm table-bordered table-striped mb-0">
                          <thead className="thead-secondary">
                            <tr className="text-center">
                              <th>Code</th>
                              <th>Description</th>
                              {/* <th>Override 13th Month<br/>Special Pay</th> */}
                              <th>Status</th>
                              <th style={{ width: "100px" }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredData.length > 0 ? (
                              currentData.map((schema) => (
                                <tr key={schema.id}>
                                  <td>{schema.code}</td>
                                  <td>{schema.description}</td>
                                  {/* <td className="text-center">{schema.override_sp_text}</td> */}
                                  <td className="text-center">
                                    <strong
                                      className={
                                        schema.status == "ACTIVE"
                                          ? "text-success"
                                          : "text-danger"
                                      }
                                    >
                                      {schema.status}
                                    </strong>
                                  </td>
                                  <td>
                                    <div className="btn-group">
                                      <Link
                                        to={{
                                          pathname: `/basic_schema/view/${schema.id}`,
                                          query: `/basic_schema`,
                                          search: "?search=" + search,
                                        }}
                                        className="btn btn-sm btn-outline-primary"
                                        title={
                                          "View " + schema.name + " Details"
                                        }
                                      >
                                        <FindInPage />
                                      </Link>
                                      {permissions > 3 ? (
                                        <DeleteSchema
                                          name={schema.description}
                                          id={schema.id}
                                          status={schema.status}
                                          parentCallback={handleAddCallback}
                                        />
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="5" className="text-center">
                                  No Data to show
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="drew-pagination">
                      {filteredData.length > 0
                        ? "Showing " +
                          (startIndex + 1) +
                          " to " +
                          (endIndex > filteredData.length
                            ? filteredData.length
                            : endIndex) +
                          " of " +
                          filteredData.length
                        : ""}
                      <ul class="pagination ml-2">
                        {pages.map((number) => (
                          <li
                            key={number}
                            id={number}
                            className={
                              currentPage == number
                                ? "paginate_button page-item active"
                                : "paginate_button page-item"
                            }
                            onClick={() => setCurrentPage(number)}
                          >
                            <a class="page-link">{number}</a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              <h1 className="m-0 text-center">
                Your credentials is not sufficient to access this:
                <br />
              </h1>
              <br />
              <h2 className="text-center">
                Module : Master Data
                <br />
                Access Type : {access[permissions]}
                <br />
                Please contact your Payroll Administrator.
                <br />
                <a className="btn btn-primary btn-sm" href="/#/app">
                  Back to Dashboard
                </a>
              </h2>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
